"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsKeyType = exports.translationObject = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _paulCorePackage = require("paul-core-package");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/** @todo move to core */
const translationsKeyType = _propTypes.default.oneOf(_paulCorePackage.constants.locales);

/** @todo move to core translationObject */
exports.translationsKeyType = translationsKeyType;
const translationObject = _propTypes.default.shape({
  [translationsKeyType]: _propTypes.default.string
});
exports.translationObject = translationObject;